import PolicyDocumentView from "../../components/public/PolicyDocumentView";

export default function Terms() {
  return <PolicyDocumentView slug="terms" fallbackTitle="Terms of Use" />;
}
